<template>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
          <h2>Let us help you calculate your Zakat</h2>

          <div class="image-container">
    <img :src="require('@/assets/muezza.png')" alt="Muezza" class="responsive-image">
  </div>

        <p>As salaamalaikum my friends and cat lovers. My name is Muezza, a name whispered through the alleys of history, echoing the affection of the Prophet Muhammad (peace be upon him) for his own feline companion. As a guardian of tales and traditions, I've been tasked with weaving through the essence of Zakat and the gentle grace of Sadaqah, guiding you through the heartbeats of generosity that pulse within the Islamic faith. </p>
        
        <p>My hooman, who has lovingly shared with me the warmth of their home and the depth of their heart, has also shared stories of a remarkable teacher, Shaykh Muhammad Alshareef, a fellow Canadian like you and I. He was a beacon of knowledge, illuminating the path of Islamic finance with wisdom and clarity, much like the glow of the moon on a clear night. His teachings, filled with insight and compassion, have left an indelible mark on many, including my beloved hooman.</p>

<p>Though Muhammad AlShareef has embarked on his journey to the gardens beyond at a young age, his legacy of enlightenment and guidance continues to inspire and resonate with all who had the privilege to learn from him. In his memory, I ask you, dear friends, to pause for a moment and send a prayer upon him. May Allah swt grant him the highest ranks in Jannah, shower him with infinite mercy, and comfort those he left behind with beautiful patience and enduring faith.</p>

<p>As we continue to explore the wonders of giving and the beauty of Zakat and Sadaqah, let's carry forward the light of knowledge he shared with us, nurturing it within our hearts and spreading its brilliance to the world around us. May our journey through the teachings of generosity also be a tribute to his memory, a prayer woven into the fabric of our learning and giving.

Thank you for joining me on this journey, and for honouring the memory of a soul who taught us so much about the beauty of our faith.</p>

<p>Zakat, you see, is not merely an act of giving; it's a divine commandment, a pillar of Islam that purifies the wealth by distributing it among those in need, thereby purifying the heart of the giver. It's distinct from Sadaqah, the voluntary charity that flows freely from the heart, without obligation, yet carries immense reward. Zakat is calculated, a precise share ordained by Allah swt, while Sadaqah is boundless, limited only by the giver's capacity and willingness.</p>

<p>Let me introduce you to the honored recipients of Zakat, as decreed in the Qur'an, their names resonating with the hope and promise of provision:</p>
<ul>

<li>The Poor (Al-Fuqara' الفقراء):  The poor who struggle to meet their basic needs.</li>
<li>The Needy (Al-Masakeen المساكين): The needy who barely survive on the margins of society.</li>
<li>The Zakat Collectors (Al-Amilina Alayha العاملين عليها): The administrators appointed to collect and distribute Zakat.</li>
<li>Those Whose Hearts Are to Be Softened (Muallafatul Qulub مؤلفة قلوبهم): Those whose hearts are to be reconciled, brought closer to Islam through kindness.</li>
<li>The Enslaved (Ar-Riqab الرقاب): The slaves and captives seeking their freedom, for whom Zakat can be a ransom.</li>
<li>The Debt-laden (Al-Gharimin الغارمين): Those burdened by debt, overwhelmed by financial obligations.</li>
<li>In the Path of Allah swt (Fi Sabilillah في سبيل الله): Those striving in the path of Allah, be it through pilgrimage or other righteous endeavors.</li>
<li>The Traveler (Ibn Al-Sabil ابن السبيل): The wayfarer, stranded travelers far from home, in need of assistance to continue their journey.</li>

</ul>
As I prance through the vibrant streets of our communities, my tales not only speak of the mechanics of giving but also of the spirit that underlies this sacred act. Zakat is a testament to faith, a commitment to the well-being of the ummah, a beacon of hope for those in darkness. Sadaqah, with its gentle touch, offers solace and support in times of need and joy, an emblem of the boundless compassion that resides in the heart of every believer.

In the soft light of dawn, as the city awakens to the call of prayer, remember the legacy of generosity that has been entrusted to us. Let the spirit of Zakat and Sadaqah guide your actions, nurturing a world where kindness reigns supreme, and no hand is left unheld, no heart untouched by the gentle grace of giving.

So, the next time a breeze carries the echo of a purr or the shadow of a whisker dances in the corner of your eye, think of me, Muezza, your guide to the timeless paths of generosity woven into the very fabric of our faith. Let us tread these paths together, for in giving, we receive, and in purifying our wealth, we purify our souls.

<p>Now, dear friends, let us embark on a mystical journey to understand the Nisab, a golden threshold that guides us in determining our Zakat. The Nisab, measured by the weight of 85 grams of gold or 595 grams of silver, serves as a celestial marker. It whispers to us, revealing whether our treasures surpass the heavens' decree, beckoning us to fulfill our sacred duty of Zakat.</p>

<p>As we tread softly on this path of calculation and contemplation, remember, the shadows cast by our worldly obligations - those immediate liabilities that tug at our robes, urging us to tend to our earthly abodes and ventures - may gently be subtracted from our bountiful troves. From the coins destined for the morrow's bread to the silver owed for the lantern's glow, these are the deductions allowed by the wise and compassionate, ensuring our journey towards generosity does not leave us wanting.</p>

<p>And thus, with hearts light and intentions pure, we navigate the realms of gold and silver, of wealth both vast and modest, guided by Muezza's gentle purr and the wisdom of ages past. May our offerings, calculated with care and given with love, be a testament to our journey through the timeless paths of generosity, woven into the very fabric of our faith.</p>

<div class="wrapper">
<div id="gold-widget" class="tradingview-widget-container">
      <div class="tradingview-widget-container__widget"></div>
    </div>
    <!-- Silver Price Widget -->
    <div id="silver-widget" class="tradingview-widget-container">
      <div class="tradingview-widget-container__widget"></div>
    </div>



<div class="zakat-calculator">
    <h2>Zakat Calculator</h2>
    <table>
      <thead>
        <tr>
          <th>Type of Wealth</th>
          <th>Amount ($)</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(amount, type) in wealthTypes" :key="type">
          <td>{{ type }}</td>
          <td><input v-model.number="wealthTypes[type]" type="number" placeholder="Enter amount" /></td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th>Total Zakat Due:</th>
          <td>{{ calculateZakatDue() }}</td>
        </tr>
      </tfoot>
    </table></div></div></div></div></div>
  <br><br><br><br>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue';

export default {
  setup() {
    const state = reactive({
      wealthTypes: {
        'Cash at Home & Bank Accounts': 0,
        'Money owed to you': 0,
        'RRSP, TFSA, FHSA or RESP Savings': 0,
        'Investment Accounts': 0,
        'Investment Property & Fixed Assets': 0,
        'Business Assets - Cash': 0,
        'Value of inventory / finished goods': 0,
        'Value of work in progress / materials': 0,
        'Value of accounts receivables': 0,
      },
      nisabThreshold: 606.23, // Example, adjust based on current value
    });

    const loadWidget = (widgetDetails) => {
      const { containerId, symbol } = widgetDetails;
      const script = document.createElement('script');
      script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js';
      script.async = true;
      script.innerHTML = JSON.stringify({
        "symbol": symbol,
        "width": 350,
        "isTransparent": false,
        "colorTheme": "light",
        "locale": "en"
      });

      document.getElementById(containerId).appendChild(script);
    };

    onMounted(() => {
      // Load separate widgets for Gold and Silver
      loadWidget({ containerId: 'gold-widget', symbol: 'XAUUSD' });
      loadWidget({ containerId: 'silver-widget', symbol: 'XAGUSD' });
    });

    function calculateZakatDue() {
      let totalAssets = Object.values(state.wealthTypes).reduce((acc, val) => acc + val, 0);
      return totalAssets > state.nisabThreshold ? (totalAssets * 0.025).toFixed(2) : '0.00';
    }

    return {
      ...toRefs(state),
      calculateZakatDue,
    };
  }
};
</script>


<style scoped>
.wrapper {
display: flex;
flex-direction: column;
align-items: center;
}

.content-container {
background-color: #4A148C ;  /* Light orange color */
color: black;
padding: 20px;
border-radius: 20px;  /* Adjust this value to your preference */
overflow: hidden; 
}
.stingy-card {
flex: 1;  /* Take up equal width as the iframe */
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white
}

.stylish-links {
background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
padding: 20px;
border-radius: 10px;
box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.stylish-links h3 {
color: #333;
font-size: 1.4em;
margin-bottom: 15px;
}

.stylish-links ul {
list-style: none;
padding: 0;
}

.stylish-links ul li {
background-color: #fff;
margin: 10px 0;
padding: 10px;
border-radius: 8px;
box-shadow: 0 2px 4px rgba(0,0,0,0.1);
transition: all 0.3s ease;
}

.stylish-links ul li a {
color: black;
text-decoration: none;
font-weight: bold;
}

.stylish-links ul li:hover {
background-color: #4A148C;
}

.stylish-links ul li:hover a {
color: #fff;
}

.image-container {
  display: flex;
  justify-content: center; /* Centers the image horizontally */
  align-items: center; /* Centers the image vertically */
  overflow: hidden; /* Ensures the image doesn't overflow the container */
}

.responsive-image {
  max-width: 100%; /* Makes the image's width responsive to the container */
  height: auto; /* Maintains the aspect ratio of the image */
  /* Adjust the max-height to fit your design needs */
  max-height: 300px; /* Example max-height to control the size further */
}

.zakat-calculator .input-group {
  margin-bottom: 1rem;
}

.zakat-calculator .nisab {
  margin-top: 1rem;
  margin-bottom: 2rem;
}
</style>